import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12ea9cd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "divider" }
const _hoisted_3 = { class: "flex md:hidden" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/3 md:block md:w-1/4" }, null, -1))
const _hoisted_5 = { class: "o-text-h4 mb-20 md:w-1/2" }
const _hoisted_6 = { class: "flex flex-wrap md:flex-nowrap" }
const _hoisted_7 = { class: "w-full flex flex-row-reverse md:flex-row" }
const _hoisted_8 = { class: "o-text-h4 mb-20 hidden md:block" }
const _hoisted_9 = {
  key: 0,
  class: "absolute right-0 top-0 z-1 mt-20 px-10 pt-3 pb-2 bg-black text-white not-italic o-text-caption md:right-auto md:left-0"
}
const _hoisted_10 = { class: "mt-20 mb-40 w-full ml-auto md:w-1/3 md:mt-0 md:flex md:flex-col md:mt-auto md:mb-0 lg:mb-0 lg:mt-0" }
const _hoisted_11 = { class: "md:ml-auto md:h-full md:flex md:flex-col md:justify-end" }
const _hoisted_12 = {
  key: 1,
  class: "min-w-200 flex flex-nowrap whitespace-nowrap mb-7 lg:min-w-250 o-text-h3"
}
const _hoisted_13 = { class: "ml-auto pl-20" }
const _hoisted_14 = {
  key: 2,
  class: "min-w-200 flex flex-nowrap whitespace-nowrap mb-7 lg:min-w-250"
}
const _hoisted_15 = { class: "ml-auto pl-20" }
const _hoisted_16 = { class: "flex mt-20 w-auto flex-row-reverse md:flex-col justify-between md:mt-10" }
const _hoisted_17 = { class: "text-right" }
const _hoisted_18 = { class: "c-magic-line text-dusty-grey" }

import { withDefaults, Ref, ref, computed } from 'vue';
import wishListsStore from '@/b2c/wishlists/wish-lists.store';
import ProductSpecs from '@/b2c/shared/product/ui/ProductSpecs.vue';
import { WishListItem } from '@/b2c/shared/api/server-apis';
import BaseDialog from '@/shared/dialog/BaseDialog.vue';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import WishListItemDiscount from '@/b2c/wishlists/ui/WishListItemDiscount.vue';
import siteContextService from '@/b2c/shared/site-context.service';
import basketTrackingService from '@/shared/tracking/basket-tracking.service';
import AddToBasket from '@/b2c/shared/checkout/ui/AddToBasket.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishListItem',
  props: {
    item: null,
    readonly: { type: Boolean, default: false },
    allowAddToBasket: { type: Boolean, default: true },
    isPublic: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { item: WishListItem, readonly: boolean, allowAddToBasket: boolean, isPublic?: boolean }



const showDeleteItem: Ref<boolean> = ref(false);
const id = useRouteQuery(QueryKeys.Id);

const canAddToBasket = computed(() => {
    return props.allowAddToBasket && !siteContextService.isBrandSite;
});

const deleteItem = async(): Promise<void> => {
    if (id.value) {
        await wishListsStore.deleteItem(id.value, props.item.id);
        showDeleteItem.value = false;
    }
};

const trackAddToBasket = (): void => {
    basketTrackingService.wishlistItem(props.item, props.isPublic);
};

return (_ctx: any,_cache: any) => {
  const _component_PDPLink = _resolveComponent("PDPLink")!
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _createVNode(_component_PDPLink, {
            sku: __props.item.variant.sku,
            title: __props.item.variant.name,
            disabled: !__props.item.isPurchasable,
            class: _normalizeClass({'c-magic-line': __props.item.isPurchasable})
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.item.variant.name), 1)
            ]),
            _: 1
          }, 8, ["sku", "title", "disabled", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-2/3 md:pr-gutter", {'opacity-35': !__props.item.isPurchasable}])
          }, [
            _createElementVNode("p", _hoisted_8, [
              _createVNode(_component_PDPLink, {
                sku: __props.item.variant.sku,
                title: __props.item.variant.name,
                disabled: !__props.item.isPurchasable,
                class: _normalizeClass({'c-magic-line': __props.item.isPurchasable})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.item.variant.name), 1)
                ]),
                _: 1
              }, 8, ["sku", "title", "disabled", "class"])
            ]),
            _createVNode(ProductSpecs, {
              variant: __props.item.variant
            }, null, 8, ["variant"])
          ], 2),
          _createVNode(_component_PDPLink, {
            sku: __props.item.variant.sku,
            title: __props.item.variant.name,
            disabled: !__props.item.isPurchasable,
            class: "relative w-1/3 p-10 md:order-first md:px-35 md:pl-0 lg:pr-35 lg:mt-10 lg:w-1/4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ProductImage, {
                sku: __props.item.variant.sku,
                alt: __props.item.variant.name,
                "width-on-screen": 20,
                class: _normalizeClass({'opacity-35': !__props.item.isPurchasable}),
                "cache-bust": __props.item.variant.imageVersion
              }, null, 8, ["sku", "alt", "class", "cache-bust"]),
              (!__props.item.isPurchasable)
                ? (_openBlock(), _createElementBlock("em", _hoisted_9, _toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/discontinued')), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["sku", "title", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: _normalizeClass([{'opacity-35': !__props.item.isPurchasable}, "w-2/3 ml-auto sm:w-220 sm:ml-auto md:ml-0 md:w-auto"])
            }, [
              (__props.item.price.discount)
                ? (_openBlock(), _createBlock(WishListItemDiscount, {
                    key: 0,
                    price: __props.item.price
                  }, null, 8, ["price"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(__props.item.price.salesPrice.amount), 1)
                  ])),
              (__props.item.price.ecoTaxPrice?.amount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/ecoTax')) + " ", 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(__props.item.price.ecoTaxPrice.amount), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", _hoisted_16, [
              (_unref(canAddToBasket))
                ? (_openBlock(), _createBlock(AddToBasket, {
                    key: 0,
                    items: [{sku: __props.item.variant.sku, purchaseOptions: __props.item.purchaseOptions, variantId: __props.item.variant.sku }],
                    "allow-add-to-basket": __props.allowAddToBasket,
                    class: "w-2/3 sm:w-220 md:w-300 lg:ml-auto",
                    onAddToBasket: trackAddToBasket
                  }, {
                    "not-buyable-from-current-location": _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_PDPLink, {
                          sku: __props.item.variant.sku,
                          title: __props.item.variant.name,
                          disabled: !__props.item.isPurchasable,
                          class: _normalizeClass({'c-magic-line': __props.item.isPurchasable})
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/wishlist/seeWishListItemPurchaseOptions')), 1)
                          ]),
                          _: 1
                        }, 8, ["sku", "title", "disabled", "class"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["items", "allow-add-to-basket"]))
                : _createCommentVNode("", true),
              (!__props.readonly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(BaseDialog, {
                      "is-open": showDeleteItem.value,
                      "onUpdate:is-open": _cache[0] || (_cache[0] = ($event: any) => ((showDeleteItem).value = $event)),
                      title: _ctx.$dictionary.get('b2c/productDetailItem/removeFromListConfirmText'),
                      description: _ctx.$dictionary.get('b2c/productDetailItem/removingFromList', [__props.item.variant.name]),
                      "cancel-button": _ctx.$dictionary.get('b2c/productDetailItem/cancel'),
                      "confirm-button": _ctx.$dictionary.get('b2c/productDetailItem/removeFromListBtn'),
                      "confirm-method": deleteItem
                    }, null, 8, ["is-open", "title", "description", "cancel-button", "confirm-button"]),
                    _createElementVNode("button", {
                      class: "md:mt-20 md:ml-auto",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showDeleteItem.value = true), ["prevent"]))
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$dictionary.get('b2c/productDetailItem/removeItem')), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})